// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3JFbp","consentsList":"PatientConsents_consentsList__1cS4E","consentsListEmpty":"PatientConsents_consentsListEmpty__2-wy0"};